import { useEffect, useState } from 'react'
import { useIsFeatureEnabled } from '.'
import { DEFAULT_FEATURE_TOGGLE_VALUES } from './utils'

const LOCALIZATION_VERIFICATION_FEATURE_FLAG =
  'is-localization-verification-enabled'

export const useIsLocalizationVerificationEnabled = (): {
  isLocalizationVerificationEnabled: boolean
  isLoading: boolean
} => {
  const isFeatureEnabled = useIsFeatureEnabled(
    LOCALIZATION_VERIFICATION_FEATURE_FLAG
  )
  const [
    isLocalizationVerificationEnabled,
    setIsLocalizationVerificationEnabled,
  ] = useState<boolean>(
    Boolean(
      DEFAULT_FEATURE_TOGGLE_VALUES[LOCALIZATION_VERIFICATION_FEATURE_FLAG]
    )
  )
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    isFeatureEnabled()
      .then((value) => {
        setIsLocalizationVerificationEnabled(Boolean(value))
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  return { isLocalizationVerificationEnabled, isLoading }
}
